module.exports = __webpack_public_path__ + "58d3816792b95b107038b6324208b6ec.png";